import { gql } from "@apollo/client";

export const AskAIMeetingEmbedFragment = gql`
  fragment AskAIMeetingEmbedFragment on MeetingNode {
    id
    title
    startDatetime
    endDatetime
    meetingGroupId
    meetingGroup {
      id
      isFormalOneonone
    }
    topics {
      totalCount
      edges {
        node {
          id
          title
          discussionNotes
        }
      }
    }
    participants {
      totalCount
      edges {
        node {
          id
          user {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;

export default gql`
  ${AskAIMeetingEmbedFragment}
  query getAskAIMeetingEmbedQuery($meetingId: Int!) {
    meeting(meetingId: $meetingId) {
      ...AskAIMeetingEmbedFragment
    }
  }
`;
